const WorkData = [
  {
    key: 1,
    title: "Flexible Environment",
    desc: "We provide flexible working hours and remote jobs to provide work-life balance.",
    image: require("../../assets/images/work-with-us/work-3.png"),
  },
  {
    key: 2,
    title: "Growth",
    desc: "We provide in-house pieces of training and time to learn new technologies to grow in your career.",
    image: require("../../assets/images/work-with-us/work-1.png"),
  },
  {
    key: 3,
    title: "Medical Insurance",
    desc: "We provide medical insurance to our permanent employees.",
    image: require("../../assets/images/work-with-us/work-2.png"),
  },
  {
    key: 4,
    title: "Paid Leaves",
    desc: "We provide paid leaves to our permanent employees as per the defined policy.",
    image: require("../../assets/images/work-with-us/work-3.png"),
  },
  {
    key: 5,
    title: "In-house Meals",
    desc: "An in-house meal is provided to the permanent staff who works from the office premises.",
    image: require("../../assets/images/work-with-us/work-1.png"),
  },
  {
    key: 6,
    title: "Indoor games",
    desc: "Indoor games are placed for our permanent staff who perform their duties from the office premises.",
    image: require("../../assets/images/work-with-us/work-2.png"),
  },
];

export default WorkData;
